import { Select, Form } from "antd";
import { useTranslation } from "react-i18next";

import { INTERVENTION_TEMPLATES_FILTERS } from "@/entities/intervention-templates";
import QueryableSelect from "@/modules/queryable-select";
import { StateTag } from "@/modules/state-tag";

import { IMPORTABLE_MODELS } from "./constants";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;
const { useForm } = Form;

const SelectModelForm = ({
  activeModel,
  selectedTemplateId,
  onActiveModelChange,
  onTemplateChange,
}) => {
  const { t } = useTranslation();
  const [form] = useForm();

  const modelsOptions = IMPORTABLE_MODELS.map((model) => (
    <Option key={model} value={model}>
      {t(`global:${model}Plural`)}
    </Option>
  ));

  const initialValues = {
    activeModel,
    template: selectedTemplateId,
  };

  const optionFormat = ({ option, fieldName }) => (
    <Option
      data-testid={`select-option-template-${fieldName}`}
      key={option.id}
      value={option.id}
    >
      <StateTag value={option.state} type="interventiontemplate" />
      {`${option.id} - ${option.name} v${option.version}`}
    </Option>
  );

  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <Form.Item name="activeModel" label={t("importTool:selectModel")}>
        <Select onChange={onActiveModelChange} data-testid="select-model">
          {modelsOptions}
        </Select>
      </Form.Item>

      {activeModel === "dataset" && (
        <QueryableSelect
          model="interventionTemplates"
          name="template"
          tableName="intervention_templates"
          filterBy="name"
          dataTestId="filterby-templates"
          label={t(`importTool:export.filterBy.interventionTemplate`)}
          placeholder={t(`importTool:export.filterBy.interventionTemplate`)}
          optionFormat={optionFormat}
          onChange={onTemplateChange}
          additionalFilters={{
            [INTERVENTION_TEMPLATES_FILTERS.ID]: selectedTemplateId,
          }}
        />
      )}
    </Form>
  );
};

export default SelectModelForm;
